import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow, Grid, FreeMode } from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {

	$(".banner-page-home .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			speed: 1000,
			effect: "fade",
			autoplay: {
				delay: 3500,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.banner-page-home').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".banner-page-home").find(".btn-next")[0],
				prevEl: $(this).closest(".banner-page-home").find(".btn-prev")[0],
			},
		});
	});

	$(".home-cols-2 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-2').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-2").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-2").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
				},
				1290: {
					slidesPerView: 2,
				},
			},
		});
	});

	$(".home-cols-3 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 30,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-3').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-3").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-3").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					spaceBetween: 40,
					slidesPerView: 3,
				},
			},
		});
	});

	$(".home-cols-3-banner .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 2,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-3-banner').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-3-banner").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-3-banner").find(".btn-prev")[0],
			},
			breakpoints: {
				1200: {
					slidesPerView: 3,
				},
			},
		});
	});

	// $(".home-cols-3-project .swiper").each(function () {
	// 	new Swiper(this, {
	// 		modules: [Autoplay, Navigation],
	// 		loop: true,
	// 		slidesPerView: 1,
	// 		spaceBetween: 20,
	// 		centeredSlides: true,
	// 		observer: true,
	// 		observeParents: true,
	// 		navigation: {
	// 			nextEl: $(this).closest(".home-cols-3-project").find(".btn-next")[0],
	// 			prevEl: $(this).closest(".home-cols-3-project").find(".btn-prev")[0],
	// 		},
	// 		breakpoints: {
	// 			768: {
	// 				slidesPerView: 1.6,
	// 			},
	// 			1200: {
	// 				spaceBetween: 40,
	// 				slidesPerView: 1.7,
	// 			},
	// 		},
	// 	});
	// });

	(function ($) {
		// Hàm khởi tạo Swiper
		function initProjectSwiper() {
			$(".home-cols-3-project .swiper").each(function () {
				// Destroy swiper cũ nếu có
				if (this.swiper) {
					this.swiper.destroy(true, true);
				}

				new Swiper(this, {
					modules: [Autoplay, Navigation],
					loop: true,
					slidesPerView: 1,
					spaceBetween: 20,
					centeredSlides: true,
					observer: true,
					observeParents: true,
					autoplay: {
						delay: 3500,
					},
					loop: true,
					navigation: {
						nextEl: $(this).closest(".home-cols-3-project").find(".btn-next")[0],
						prevEl: $(this).closest(".home-cols-3-project").find(".btn-prev")[0],
					},
					breakpoints: {
						768: {
							slidesPerView: 1.6,
						},
						1200: {
							spaceBetween: 40,
							slidesPerView: 1.7,
						},
					},
				});
			});
		}

		// Khởi tạo lần đầu khi DOM ready
		$(document).ready(function () {
			initProjectSwiper();
		});

		// Reinit sau khi FacetWP load xong
		$(document).on('facetwp-loaded', function () {
			// Delay nhỏ để đảm bảo DOM đã render xong
			setTimeout(function () {
				initProjectSwiper();
			}, 100);
		});

		// Thêm loading state khi bắt đầu filter
		$(document).on('facetwp-refresh', function () {
			$('.home-cols-3-project .list-project').addClass('is-loading');
		});

		// Xóa loading state khi load xong
		$(document).on('facetwp-loaded', function () {
			$('.home-cols-3-project .list-project').removeClass('is-loading');
		});

	})(jQuery);

	$(".home-cols-service-detail .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			speed: 1000,
			effect: "fade",
			spaceBetween: 30,
			// autoplay: {
			// 	delay: 3500,
			// },
			// loop: true,
			pagination: {
				el: $(this).closest('.home-cols-service-detail').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-service-detail").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-service-detail").find(".btn-prev")[0],
			},
		});
	});

	$(".home-cols-4 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-4').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-4").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-4").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1290: {
					slidesPerView: 4,
				},
			},
		});
	});

	$(".home-cols-5 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 2,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-5').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-5").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-5").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				1290: {
					slidesPerView: 5,
				},
			},
		});
	});

	$(".home-cols-slider-brand .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation, Grid],
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 20,
			grid: {
				rows: 2,
				fill: 'row'
			},
			loop: false,
			pagination: {
				el: $(this).closest('.home-cols-slider-brand').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-slider-brand").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-slider-brand").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 20,
					grid: {
						rows: 2,
						fill: 'row'
					}
				},
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 30,
					grid: {
						rows: 2,
						fill: 'row'
					}
				},
				1200: {
					slidesPerView: 6,
					slidesPerGroup: 6,
					spaceBetween: 40,
					grid: {
						rows: 2,
						fill: 'row'
					}
				}
			}
		});
	});



	// slider gallery
	var sliderThumbnail = new Swiper('.thumb-slider .swiper', {
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 4000,
		},
		slidesPerView: 4,
		spaceBetween: 30,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,

	});
	var mainSlider = new Swiper('.main-slider .swiper', {
		modules: [Thumbs, Autoplay, Navigation],
		navigation: {
			nextEl: '.thumb-slider .btn-next',
			prevEl: '.thumb-slider .btn-prev',
		},
		autoplay: {
			delay: 4000,
		},
		loop: true,
		thumbs: {
			swiper: sliderThumbnail
		}
	});
	// end



}
